import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=35e1f06e&scoped=true&"
import script from "./DashboardData.vue?vue&type=script&lang=js&"
export * from "./DashboardData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardData.vue?vue&type=style&index=0&id=35e1f06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1f06e",
  null
  
)

export default component.exports